import axios from 'axios';
import config from '../../config';

import tokenApi from './tokenApi';

const studentInstance = axios.create({
	baseURL: config.api,
    headers: {
		'Content-Type': 'application/json'
	}
});

class StudentApi {  

	static StudentInsert(payload) {
		studentInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return studentInstance.post('/student', payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static StudentUpdate(payload, id) {
		studentInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return studentInstance.patch(`/student/${id}`, payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static StudentList(classQuotaId) {
		studentInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return studentInstance.get(classQuotaId ? `/student?classQuotaId=${classQuotaId}` :  `/student`)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static StudentDelete(id) {
		studentInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return studentInstance.delete(`/student/${id}`)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static StudentListChange(page, pageSize) {
		studentInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return studentInstance.get(`/student?page=${page}&perPage=${pageSize}`)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static StudentSearch(title) {
		studentInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return studentInstance.get(`/student?title=${title}&perPage=100`)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

  static StudentGetResult(id) {
    studentInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return studentInstance.get(`/student/result/${id}`)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
  }

  static StudentCreateMany(payload) {
    studentInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return studentInstance.post(`/student/class`, payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
  }

  static StudentEdit(payload) {
    studentInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return studentInstance.patch(`/student/class`, payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
  }

  static StudentGetClassResult(id) {
    studentInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return studentInstance.get(`/student/class?classQuotaId=${id}`)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
  }

  static StudentGetClassReport(id) {
    studentInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return studentInstance.get(`/student/report?classQuotaId=${id}`)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
  }

  static StudentGetReport(id) {
    studentInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
    return studentInstance.get(`/student/report/${id}`, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      responseType: 'arraybuffer'
    })
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
  }
}

export default StudentApi; 


